export default "__VITE_ASSET__f060432e__"